export default __webpack_public_path__ + "static/media/h25koritu.518ae68c.mp3";